export const api = { "url" : "https://5h7kzlge3m.execute-api.us-east-1.amazonaws.com/v1/" };
